import { render } from "./HelpTooltip.vue?vue&type=template&id=642c66dd&scoped=true&ts=true"
import script from "./HelpTooltip.vue?vue&type=script&lang=ts"
export * from "./HelpTooltip.vue?vue&type=script&lang=ts"

import "./HelpTooltip.vue?vue&type=style&index=0&id=642c66dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642c66dd"]])

export default __exports__